import React from "react";
import "./Profile.css";
import { social_links } from "../../NavBarData";
import WebData from "../../../../../Helpers/WebData";

function Profile() {
  return (
    <div className="profile">
      <img
        src={WebData.Logo.image}
        className="rounded-circle img-fluid"
        alt="profile-nav-img"
      />
      <div className="social-links mt-3 text-center">
        {social_links.map((link) => {
          return (
            <a href={link.link} key={link.id}>
              {link.icon}
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default Profile;
